export default __webpack_public_path__ + "static/media/bar-ccr.76b75510.svg";